import { API_BASE_URL } from "@constants/urls";
import axios from "axios";
export async function deleteAccount(request: {
	userId: string;
	tenantId: string;
}) {
	const { data } = await axios.post(
		`${API_BASE_URL}/customer/deletion`,
		request,
	);

	return data.data;
}
